module.exports = __webpack_public_path__ + "static/media/netflix.ce186f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/netflix.png
// module id = 42
// module chunks = 0